const e=async(e,t)=>{let{data:n}=await e.get(`/apps/${t}`);return n};export{e as getApp};
//# sourceMappingURL=get-app.mjs.map